export default function pushGTMWithDelay(delay, gtmEvent, gtmEventContent) {
  // PageViewEvent depends on react-helmet so is pushed with a delay and we need it to be pushed before other events so we delay data layer events called inside this function. The reason we need to do that is because we have to make sure react-helmet is done with it's changes (https://github.com/gatsbyjs/gatsby/issues/9139)
  // reactHelmet is using requestAnimationFrame: https://github.com/nfl/react-helmet/blob/5.2.0/src/HelmetUtils.js#L296-L299
  const timer = setTimeout(() => {
    if (gtmEventContent) gtmEvent({ ...gtmEventContent });
  }, delay);
  return () => clearTimeout(timer);
}
